var TorsoView = require('backbone-torso/modules/View');
var eregAuthBarcodeTemplate = require('./eregAuthBarcodeTemplate.hbs');
var ImageReferenceDataBehavior = require('./../../branding-config/image/ImageReferenceDataBehavior');
var PreviewBehavior = require('./../../behaviors/PreviewBehavior');
var INSTRUCTIONS_IMAGE_NAME  = 'ereg-barcode-instructions';

var barcodeScanningService = require('./barcodeScanningService');

/**
 * View for E-reg patient authentication
 *
 * @class EregAuthBarcodeView
 * @constructor
 */
var EregAuthBarcodeView = TorsoView.extend({
  className: 'auth-main auth-main--express-checkin',
  template: eregAuthBarcodeTemplate,

  behaviors: {
    previewBehavior: PreviewBehavior,
    imageReferences: {
      behavior: ImageReferenceDataBehavior,
      id: INSTRUCTIONS_IMAGE_NAME
    }
  },

  events: {
    'click [data-button-capture-barcode]': barcodeScanningService.startBarcodeScanAndPolling
  },

  /**
   * @method prepare
   * @override
   */
  prepare: function() {
    var templateContext = TorsoView.prototype.prepare.apply(this);
    var imageReferenceDataBehavior = this.getBehavior('imageReferences');
    templateContext[INSTRUCTIONS_IMAGE_NAME] = {
      isNone: imageReferenceDataBehavior.isEmptyImageReference(INSTRUCTIONS_IMAGE_NAME)
    };
    return templateContext;
  }
});

EregAuthBarcodeView.INSTRUCTIONS_IMAGE_NAME = INSTRUCTIONS_IMAGE_NAME;

module.exports = EregAuthBarcodeView;
